export interface HostedPaymentUiModel {
  url: string;
}
